import type {WorkloadScore} from "../../4-scoring/performScoring.ts";
import type {Workload} from "../../3-workload-analysis/model/Workload.ts";
import type {WorkloadInput} from "../../3-workload-analysis/model/WorkloadInput.ts";
import {getWorkloadSources} from "../utils/workloadFormatting.ts";
import {DownloadWorkloadButton} from "./DownloadWorkloadButton.tsx";

/**
 * Render a single row in the active workloads table
 */
function ActiveWorkloadRow({
    workloadScore,
    getWorkloadInput,
    index
}: {
    workloadScore: WorkloadScore
    getWorkloadInput: (workload: Workload) => WorkloadInput | undefined
    index: number
}) {
    const workload = workloadScore.workload
    const sourceDisplay = getWorkloadSources(workload)
    
    return (
        <tr key={index} style={{borderBottom: '1px solid #eee'}}>
            <td style={{padding: '0.5rem'}}>
                {workload.versionId.groupName}/{workload.versionId.projectName}/{workload.versionId.versionName}
            </td>
            <td style={{padding: '0.5rem'}}>
                {workload.startingJob}
            </td>
            <td style={{textAlign: 'right', padding: '0.5rem'}}>
                {workload.tasks.length}
            </td>
            <td style={{padding: '0.5rem'}}>
                {sourceDisplay}
            </td>
            <td style={{padding: '0.5rem', textAlign: 'center'}}>
                <DownloadWorkloadButton
                    workload={workload}
                    getWorkloadInput={getWorkloadInput}
                    label="Download"
                />
            </td>
        </tr>
    )
}

/**
 * Render the active workloads table
 */
export function ActiveWorkloadsTable({
    workloadScores,
    getWorkloadInput
}: {
    workloadScores: WorkloadScore[]
    getWorkloadInput: (workload: Workload) => WorkloadInput | undefined
}) {
    if (workloadScores.length === 0) {
        return <p><em>No active workloads found in the last 31 days.</em></p>
    }

    return (
        <table style={{width: '100%', borderCollapse: 'collapse', marginTop: '1rem'}}>
            <thead>
                <tr style={{borderBottom: '2px solid #ccc'}}>
                    <th style={{textAlign: 'left', padding: '0.5rem'}}>Project</th>
                    <th style={{textAlign: 'left', padding: '0.5rem'}}>Starting Job Name</th>
                    <th style={{textAlign: 'right', padding: '0.5rem'}}>Number of Runs</th>
                    <th style={{textAlign: 'left', padding: '0.5rem'}}>Source</th>
                    <th style={{textAlign: 'center', padding: '0.5rem'}}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {workloadScores.map((workloadScore, idx) => (
                    <ActiveWorkloadRow
                        key={idx}
                        workloadScore={workloadScore}
                        getWorkloadInput={getWorkloadInput}
                        index={idx}
                    />
                ))}
            </tbody>
        </table>
    )
}
